const handler = {
    construct() {
        return handler;
    }
};
export const isConstructible = (constructible) => {
    try {
        const proxy = new Proxy(constructible, handler);
        new proxy(); // tslint:disable-line:no-unused-expression
    }
    catch (_a) {
        return false;
    }
    return true;
};
//# sourceMappingURL=/build/es2018/helpers/is-constructible.js.map